var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBundle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10003_111584)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42857 3.42856C3.11298 3.42856 2.85714 3.6844 2.85714 3.99999V14.2857C2.85714 14.6013 3.11298 14.8571 3.42857 14.8571H10.2857C10.6013 14.8571 10.8571 14.6013 10.8571 14.2857V3.99999C10.8571 3.6844 10.6013 3.42856 10.2857 3.42856H3.42857ZM1.71429 3.99999C1.71429 3.05322 2.4818 2.28571 3.42857 2.28571H10.2857C11.2325 2.28571 12 3.05322 12 3.99999V14.2857C12 15.2325 11.2325 16 10.2857 16H3.42857C2.4818 16 1.71429 15.2325 1.71429 14.2857V3.99999Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.71428C4 5.39869 4.25584 5.14285 4.57143 5.14285H9.14286C9.45845 5.14285 9.71429 5.39869 9.71429 5.71428C9.71429 6.02987 9.45845 6.28571 9.14286 6.28571H4.57143C4.25584 6.28571 4 6.02987 4 5.71428Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.57143C4 8.25584 4.25584 8 4.57143 8H9.14286C9.45845 8 9.71429 8.25584 9.71429 8.57143C9.71429 8.88702 9.45845 9.14286 9.14286 9.14286H4.57143C4.25584 9.14286 4 8.88702 4 8.57143Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.4286C4 11.113 4.25584 10.8571 4.57143 10.8571H6.85714C7.17273 10.8571 7.42857 11.113 7.42857 11.4286C7.42857 11.7442 7.17273 12 6.85714 12H4.57143C4.25584 12 4 11.7442 4 11.4286Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57143 0.571429C4.57143 0.255837 4.82727 0 5.14286 0H12.5714C13.0261 0 13.4621 0.180612 13.7836 0.502103C14.1051 0.823593 14.2857 1.25963 14.2857 1.71429V12.5714C14.2857 12.887 14.0299 13.1429 13.7143 13.1429C13.3987 13.1429 13.1429 12.887 13.1429 12.5714V1.71429C13.1429 1.56273 13.0827 1.41739 12.9755 1.31022C12.8683 1.20306 12.723 1.14286 12.5714 1.14286H5.14286C4.82727 1.14286 4.57143 0.88702 4.57143 0.571429Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10003_111584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundle);
export default __webpack_public_path__ + "static/media/bundle.02614dc6ea7b0a5aada1a8e3d83e12b5.svg";
export { ForwardRef as ReactComponent };